import { render, staticRenderFns } from "./Licensing.vue?vue&type=template&id=63a441bd&"
import script from "./Licensing.vue?vue&type=script&lang=ts&"
export * from "./Licensing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports